import React, {useState, useEffect} from 'react';
import DateTimePicker from './DateTimePricker';
import { ReactComponent as IconoBorrar } from './../imagenes/borrar.svg';
import { ReactComponent as IconoOrdenar } from './../imagenes/ordenar.svg';
import { ReactComponent as IconoEditar } from './../imagenes/editar.svg';
import {
	ContenedorSubtituloPequeño, ContenedorSubtitulo, Subtitulo, Descripcion, Lista, ElementoLista, ContenedorFiltros,Contenedor, Formulario,
	Input, ContenedorBoton,Btn, BotonAccion, ContenedorLista,ContenedorItinerario,ContenedorInputConIcono,ContenedorInputconLabel,BotonOrdenaItinerario
} from '../elementos/ElementosDeFormulario';
import Boton from './../elementos/Boton';
import {ReactComponent as IconoPlus} from './../imagenes/plus.svg';
import SelectClientes from './SelectClientes';
import SelectClientesMutual from './SelectClientesMutual';
import {db} from '../firebase/firebaseConfig';
import { ref, push, set, update } from "firebase/database";
import {ContenedorBotones} from '.././elementos/Header';
import { ReactComponent as IconoEstado } from '.././imagenes/estado.svg';
import { ReactComponent as IconoRetorno } from '.././imagenes/retorno2.svg';
import {ReactComponent as IconoDown} from './../imagenes/down.svg';
import {ReactComponent as IconoUp} from './../imagenes/up.svg';
import Iconotipo from '../elementos/IconoItinerario';
import Alerta from './../elementos/Alerta';
import { useAuth } from './../contextos/AuthContext';
import { useNavigate } from 'react-router-dom';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faHashtag,faPhone,faEnvelope,faUser, faToggleOn,faAddressCard,faPalette,faCar,faCarTunnel,faTrailer, faLocationCrosshairs} from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2';
import SelectMoviles15edit from './SelectMoviles15';

const FormularioEditaViaje = ({id, viaje, itinerario, cambiarItinerario, listadoPasajeros, cambiarListadoPasajeros, cliente, cambiarCliente,
    cambiarVerFormularioViaje,Escliente,UsarioLog,cambiarEditaPasajero,EditaPasajero,CambiarTelefoPasajeroEdit,TelefoPasajeroEdit,fechahoraviaje, cambiarFechahoraviaje}) => {
    const {usuario} = useAuth();
    const navigate = useNavigate();
    //const [fechahoraviaje, cambiarFechahoraviaje] = useState (null);
    const [fecha_hora_creacion, cambiarfecha_hora_creacion] = useState (new Date());
    const [clientep, cambiarClientep] = useState ('Seleccione Cliente');
    const [estado, cambiarEstado] = useState ('Programado');
    const [movil, CambiarMovil] = useState({numero:"Movil"});
    const [comentarios, CambiarComentarios] = useState('');
    const [folio, cambiarFolio] = useState('');
    const [kmfolio, cambiarKmfolio] = useState('');
    const [vuelo, cambiarVuelo] = useState('');
    const [muestraFolio, cambiarMuestraFolio] = useState(true);
    const [ordenado, CambiarOrdenado] = useState('');
    
    const [alerta, cambiarAlerta] = useState({});
    const [estadoAlerta, cambiarEstadoAlerta] = useState(false);
   useEffect (()=>{
    viaje.empresa && cambiarClientep(viaje.empresa);
    viaje.folio && cambiarFolio(viaje.folio);
    viaje.kmfolio && cambiarKmfolio(viaje.kmfolio);
    viaje.n_vuelo && cambiarVuelo(viaje.n_vuelo);
    
    viaje.numero_m && CambiarMovil({
        numero:  viaje.numero_m,
        color: viaje.color_m,
        nombre: viaje.nombre_m,
        patente: viaje.patente_m,
        telefono: viaje.telefono_m,
        tipo: viaje.tipo_m
    });
    viaje.fecha_hora_programada && cambiarFechahoraviaje(new Date(viaje.fecha_hora_programada));
    viaje.itinerario && cambiarItinerario(Object.keys(viaje.itinerario).map(function (key) {return {id : key, ...viaje.itinerario[key]};}))
    viaje.pasajeros && cambiarListadoPasajeros(Object.keys(viaje.pasajeros).map(function (key) {return {id : key, ...viaje.pasajeros[key]};}))
    viaje.comentarios && CambiarComentarios(viaje.comentarios);    
    viaje.estado && cambiarEstado(viaje.estado);
    viaje.fecha_hora_creacion && cambiarfecha_hora_creacion(new Date(viaje.fecha_hora_creacion));
    },[viaje]);
    


    function toTimestamp(strDate){
        var datum = Date.parse(strDate);
        return datum;
     }

    const BorrarPasajero = (TelefoPasajero) => {  
            const filtradositinerario = itinerario.filter(item => item.telefono !== TelefoPasajero)
            cambiarItinerario(filtradositinerario)
            const filtradosListadoPasajeros = listadoPasajeros.filter(item => item.telefono !== TelefoPasajero)
            cambiarListadoPasajeros(filtradosListadoPasajeros)
        }

    const EditarPasajero = (TelefoPasajero) => { 

        if(EditaPasajero === false){
            Swal.fire({
                title: 'Ya esta un pasajero en edicion',
                text: 'Termine edicion anterior',
                icon: 'error',
                timer:2000
                })
			return;
		} else{
            cambiarEditaPasajero(!EditaPasajero)
            CambiarTelefoPasajeroEdit(TelefoPasajero)

           console.log(TelefoPasajero)
        }
    }    
    


    const Ordenar = () => {  
        
        itinerario.sort((a, b) => ((a.tipo) < (b.tipo) ? 1 : (a.tipo) > (b.tipo) ? -1 : 0))
        CambiarOrdenado(ordenado+'ordenado')
    }

    const Subir = (indexitinerario) => {  
        if(indexitinerario>0) {
            if(itinerario[indexitinerario].telefono!==itinerario[indexitinerario-1].telefono){
                const indexitinerarioa = itinerario[indexitinerario]
                const indexitinerariob = itinerario[indexitinerario-1]
                itinerario.splice(indexitinerario, 1, indexitinerariob);
                itinerario.splice(indexitinerario-1, 1, indexitinerarioa);
                CambiarOrdenado(ordenado+'ordenado')
            }else{
                cambiarEstadoAlerta(true);
                cambiarAlerta({
                    tipo: 'error',
                    mensaje: 'El destino no puede estar antes del origen'
                });
            }
       }else{
            cambiarEstadoAlerta(true);
            cambiarAlerta({
                tipo: 'error',
                mensaje: 'No se puede subir el registro'
            });
          }
        } 

    const Bajar = (indexitinerario) => {  
        if(itinerario.includes(itinerario[indexitinerario+1])) {
            if(itinerario[indexitinerario].telefono!==itinerario[indexitinerario+1].telefono){
                const indexitinerarioa = itinerario[indexitinerario]
                const indexitinerariob = itinerario[indexitinerario+1]
                itinerario.splice(indexitinerario, 1, indexitinerariob);
                itinerario.splice(indexitinerario+1, 1, indexitinerarioa);
                CambiarOrdenado(ordenado+'ordenado')
            }else{
                    cambiarEstadoAlerta(true);
                    cambiarAlerta({
                        tipo: 'error',
                        mensaje: 'El destino no puede estar antes del origen'
                    });
                }
          }else{
            cambiarEstadoAlerta(true);
            cambiarAlerta({
                tipo: 'error',
                mensaje: 'No se puede bajar el registro'
            });
          }
    }

    const handleChange = (e) => {
		if(e.target.name === 'movil'){
			CambiarMovil(e.target.value);
		} else if (e.target.name === 'comentarios'){
			CambiarComentarios(e.target.value);
		} else if (e.target.name === 'folio'){
			cambiarFolio(e.target.value);
		} else if (e.target.name === 'kmfolio'){
			cambiarKmfolio(e.target.value);
		} else if (e.target.name === 'vuelo'){
			cambiarVuelo(e.target.value);
		}
	}

   useEffect (()=>{    
        if(movil.numero !== 'Movil')
        {cambiarEstado('Asignado');}
        else {cambiarEstado('Programado');};
    },[movil]);

    useEffect (()=>{    
        if(clientep === 'METRO' || clientep === 'Metro' )
        {cambiarMuestraFolio(false);} else {cambiarMuestraFolio(true);} 
    },[clientep]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if(clientep === 'Seleccione Cliente' || clientep === undefined){
            cambiarEstadoAlerta(true);
			cambiarAlerta({
				tipo: 'error',
				mensaje: 'Por favor selecciona cliente'
			});
			return;
		}

        if(fechahoraviaje === null){
			cambiarEstadoAlerta(true);
			cambiarAlerta({
				tipo: 'error',
				mensaje: 'Seleccione fecha y hora de viaje'
			});
			return;
		}

        if(itinerario.length === 0 || listadoPasajeros.length === 0){
			cambiarEstadoAlerta(true);
			cambiarAlerta({
				tipo: 'error',
				mensaje: 'Seleccione pasajero para trasladar'
			});
			return;
		}





        if(movil.numero === 'Movil' || movil.numero === undefined){
            const postListRef = ref(db, 'projects/proj_6wVhReGA6EM5z4Jew4js7T/data/traslados');

            update(ref(db,'projects/proj_6wVhReGA6EM5z4Jew4js7T/data/traslados/'+id),
            {   estado: estado,
                fecha_hora_programada: toTimestamp(fechahoraviaje),
                folio: folio,
                kmfolio: kmfolio,
                n_vuelo: vuelo,
                empresa: clientep,
                comentarios: comentarios,
                itinerario: null,
                pasajeros: null,
                fecha_hora_modificacion : toTimestamp(fecha_hora_creacion),
                modificador : usuario.uid
            })
            
            //cambiar hora de primer pasajero
            listadoPasajeros.map((pasajeroT,index) => {
                if (index===0){
                    pasajeroT.fechahoraviajep = toTimestamp(fechahoraviaje)
                    }
            })

            const opostListRef = ref(db, 'projects/proj_6wVhReGA6EM5z4Jew4js7T/data/traslados/'+id+'/pasajeros');
            await listadoPasajeros.map (pasajeroTraslado  =>{           
                const onewPostRef = push(opostListRef);
                set(onewPostRef, pasajeroTraslado)
            })

            //cambiar hora de primer itinerario
            itinerario.map((pasajeroIT,index) => {
                if (index===0){
                    pasajeroIT.fechahoraviajep = toTimestamp(fechahoraviaje)
                }
            })

            const opostItitRef = ref(db, 'projects/proj_6wVhReGA6EM5z4Jew4js7T/data/traslados/'+id+'/itinerario');
            await itinerario.map (pasajeroitinerario  =>{           
                const onewPostRef = push(opostItitRef);
                set(onewPostRef, pasajeroitinerario)
            })

            if(cliente==='Seleccione Cliente' && clientep !=='Seleccione Cliente')
            {
              cambiarCliente(clientep)
            }
            cambiarEstadoAlerta(true);
                cambiarAlerta({
                    tipo: 'exito',
                    mensaje: 'El viaje fue actualizado sin Movil, quedara en estado Programado'
                });
            
            cambiarItinerario([]);
            cambiarListadoPasajeros([]);
            CambiarComentarios('');
            cambiarFolio('');
            cambiarKmfolio('');
            cambiarMuestraFolio(true);
            setTimeout(() => {navigate('/listar-activos')}, 2000);
            
		} else {
            const postListRef = ref(db, 'projects/proj_6wVhReGA6EM5z4Jew4js7T/data/traslados');

            await update(ref(db,'projects/proj_6wVhReGA6EM5z4Jew4js7T/data/traslados/'+id),
            {   estado: estado,
                fecha_hora_programada: toTimestamp(fechahoraviaje),
                numero_m: movil.numero,
                color_m: movil.color,
                nombre_m: movil.nombre,
                patente_m: movil.patente,
                telefono_m: movil.telefono,
                tipo_m: movil.tipo,
                empresa: clientep,
                folio: folio,
                kmfolio: kmfolio,
                n_vuelo: vuelo,
                comentarios: comentarios,
                itinerario: null,
                pasajeros: null,
                fecha_hora_modificacion : toTimestamp(fecha_hora_creacion),
                modificador : usuario.uid
            })

            //cambiar hora de primer pasajero
            listadoPasajeros.map((pasajeroT,index) => {
                if (index===0){
                    pasajeroT.fechahoraviajep = toTimestamp(fechahoraviaje)
                    }
            })


            const opostListRef = ref(db, 'projects/proj_6wVhReGA6EM5z4Jew4js7T/data/traslados/'+id+'/pasajeros');
            await listadoPasajeros.map (pasajeroTraslado =>{           
                const onewPostRef = push(opostListRef);
                set(onewPostRef, pasajeroTraslado)
            })

            //cambiar hora de primer itinerario
            itinerario.map((pasajeroIT,index) => {
                if (index===0){
                    pasajeroIT.fechahoraviajep = toTimestamp(fechahoraviaje)
                }
            })

            const opostItitRef = ref(db, 'projects/proj_6wVhReGA6EM5z4Jew4js7T/data/traslados/'+id+'/itinerario');
            await itinerario.map (pasajeroitinerario  =>{           
                const onewPostRef = push(opostItitRef);
                set(onewPostRef, pasajeroitinerario)
            })

            if(cliente==='Seleccione Cliente' && clientep !=='Seleccione Cliente')
            {
              cambiarCliente(clientep)
            }


            cambiarEstadoAlerta(true);
                cambiarAlerta({
                    tipo: 'exito',
                    mensaje: 'Traslado Actualizado con exito'
                });

            cambiarItinerario([]);
            cambiarListadoPasajeros([]);
            CambiarComentarios('');
            cambiarFolio('');
            cambiarKmfolio('');
            cambiarMuestraFolio(true);
            console.log("entra")
            setTimeout(() => {navigate('/listar-activos')}, 2000);
            console.log("sale")
    }   

    }

    return (  
                
                    <Formulario onSubmit={handleSubmit}>
                        <Contenedor>
                        <main>   
                        
                        <ContenedorSubtitulo><Subtitulo>&nbsp;&nbsp;Datos de Traslado</Subtitulo></ContenedorSubtitulo>
                        
                        <ContenedorFiltros>
                        {(Escliente) 
                      ? <ContenedorInputconLabel><p>Movil</p><Input name="movil" type="text" placeholder="Movil" value={movil.numero} disabled = {true}/></ContenedorInputconLabel>
                      : <ContenedorInputconLabel><p>Movil</p><SelectMoviles15edit movil={movil} CambiarMovil={CambiarMovil} fechahoraviaje={fechahoraviaje} id={id}/></ContenedorInputconLabel>
                    }

                        {!(Escliente) 
                      ? <ContenedorInputconLabel><p>Empresa</p><SelectClientes cliente={clientep} cambiarCliente={cambiarClientep}/></ContenedorInputconLabel>
                      : !(UsarioLog.empresa==='Grupo Mutual') 
                      ? <ContenedorInputconLabel><p>Empresa Mutual</p><SelectClientesMutual cliente={clientep} cambiarCliente={cambiarClientep}/></ContenedorInputconLabel>
                      : <ContenedorInputconLabel><p>Empresa</p><Input name="empresa" type="text" placeholder="Empresa" value={clientep} disabled = {true}/></ContenedorInputconLabel>
                      
                    }

                        <ContenedorInputconLabel><p>Fecha-Hora</p><DateTimePicker fechahoraviaje={fechahoraviaje} cambiarFechahoraviaje={cambiarFechahoraviaje}/></ContenedorInputconLabel>
                        </ContenedorFiltros>
                        <ContenedorFiltros>
                        <ContenedorInputconLabel><p>Folio</p><Input name="folio" type="text" placeholder="-- " value={folio} onChange={handleChange} /></ContenedorInputconLabel>
                        <div hidden={muestraFolio}>
                        
                        <ContenedorInputconLabel><p>KMS</p><Input name="kmfolio" type="text" placeholder="--" value={kmfolio} onChange={handleChange}/></ContenedorInputconLabel>
                        </div>
                        <ContenedorInputconLabel><p>Numero de Vuelo</p><Input name="vuelo" type="text" placeholder="--" value={vuelo} onChange={handleChange}/></ContenedorInputconLabel>
                        
                         </ContenedorFiltros>
                        <ContenedorSubtitulo>
                            <Subtitulo>&nbsp;&nbsp;Itinerario de Viaje &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Subtitulo>   
                            <BotonOrdenaItinerario onClick={(e) => {e.preventDefault();Ordenar()}}> Ordenar Itinerario&nbsp;&nbsp;<IconoOrdenar fill="white"/></BotonOrdenaItinerario>
                            </ContenedorSubtitulo>
                        
                        <Lista>
                        {itinerario.map((pasajerol, index) =>{
                                //console.log(pasajerol)
                                return(
                                    
                                <ElementoLista key={pasajerol.id}>
                                    
                                    <ContenedorLista>
                                        
                                    <ContenedorItinerario>
                                    <ContenedorInputconLabel><p>Orden</p><Input name="orden_p" type="text" placeholder="Orden" value={index+1} disabled = {true}/></ContenedorInputconLabel>
                                    <ContenedorInputconLabel><p>Nombre Pasajero</p> <Input name="telefono_p" type="text" placeholder="Telefono Pasajero" value={pasajerol.nombre} disabled = {true}/> </ContenedorInputconLabel>
                                    <ContenedorInputconLabel><p>{pasajerol.tipo}</p><Input name="tipo_i" type="text" placeholder="Tipo Traslado" value={pasajerol.direccion} disabled = {true}/> </ContenedorInputconLabel>
                                     </ContenedorItinerario>
                                        
                                        <ContenedorBotones>
                                            <BotonAccion onClick={(e) => {
                                                e.preventDefault();
                                                BorrarPasajero(pasajerol.telefono)}}><IconoBorrar/></BotonAccion>
                                            <BotonAccion onClick={(e) => {
                                                e.preventDefault();
                                                Subir(index)}}><IconoUp/></BotonAccion>
                                            <BotonAccion onClick={(e) => {
                                                e.preventDefault();
                                                Bajar(index)}}><IconoDown/></BotonAccion>
                                            <BotonAccion onClick={(e) => {
                                                e.preventDefault();
                                                EditarPasajero(pasajerol.telefono)}}><IconoEditar/></BotonAccion>
                                        </ContenedorBotones>
                                    </ContenedorLista>
                                </ElementoLista>
                                )
                        })}
                        </Lista>                       

                        
                        </main>
                        
                        
                        <ContenedorSubtituloPequeño><Subtitulo>Comentarios</Subtitulo></ContenedorSubtituloPequeño>
                        <Input type="text" name="comentarios" placeholder="Comentarios"value={comentarios} onChange={handleChange}/>
                        <ContenedorBoton><Boton as="button" primario conIcono type="submit"> Guardar&nbsp;&nbsp; <IconoPlus/></Boton></ContenedorBoton>
                        
                        </Contenedor>
                        <Alerta 
                tipo={alerta.tipo}
                mensaje={alerta.mensaje}
                estadoAlerta={estadoAlerta}
                cambiarEstadoAlerta={cambiarEstadoAlerta}
            />
                    </Formulario>
    );
}
 
export default FormularioEditaViaje;